var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseHoldHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_12173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81836 29.0503V46.2378H20.3184V33.7378C20.3184 32.909 20.6476 32.1142 21.2336 31.5281C21.8197 30.942 22.6146 30.6128 23.4434 30.6128H26.5684C27.3972 30.6128 28.192 30.942 28.7781 31.5281C29.3641 32.1142 29.6934 32.909 29.6934 33.7378V46.2378H42.1934V29.0503M1.56836 25.9253L22.7954 4.69823C23.0857 4.40783 23.4302 4.17747 23.8095 4.02029C24.1888 3.86312 24.5953 3.78223 25.0059 3.78223C25.4164 3.78223 25.8229 3.86312 26.2022 4.02029C26.5815 4.17747 26.9261 4.40783 27.2163 4.69823L48.4434 25.9253",
    stroke: "#26A195",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_12173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseHoldHelp);
export default __webpack_public_path__ + "static/media/house-hold-help.578e464a3c078d33850647c6031d9d8a.svg";
export { ForwardRef as ReactComponent };